import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiGlobe } from 'react-icons/fi';

// Este componente permite cambiar el idioma manualmente
const LanguageSelector: React.FC = () => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language.startsWith('es') ? 'es' : 'en';

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    const isSpanish = currentLanguage === 'es';

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FiGlobe style={{ color: 'var(--color-texto-secundario)', fontSize: '1.2rem' }} />
            
            <button
                onClick={() => changeLanguage('es')}
                style={{
                    padding: '6px 10px',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: isSpanish ? '700' : '500',
                    backgroundColor: isSpanish ? 'var(--color-secundario)' : 'transparent',
                    color: isSpanish ? 'var(--color-primario)' : 'var(--color-texto-secundario)',
                    transition: 'all 0.2s'
                }}
            >
                ES
            </button>
            <button
                onClick={() => changeLanguage('en')}
                style={{
                    padding: '6px 10px',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: !isSpanish ? '700' : '500',
                    backgroundColor: !isSpanish ? 'var(--color-secundario)' : 'transparent',
                    color: !isSpanish ? 'var(--color-primario)' : 'var(--color-texto-secundario)',
                    transition: 'all 0.2s'
                }}
            >
                EN
            </button>
        </div>
    );
};

export default LanguageSelector;